import React from "react";
import {
  Box,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";

const PersonalInfo = ({ formik }) => {
  return (
    <>
      <Box>
        <Typography variant="h4">Personal Information</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            margin: "20px 0",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <InputLabel htmlFor="fullName">Full Name</InputLabel>
            <TextField
              type="text"
              id="fullName"
              name="full_name"
              value={formik.values.full_name}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              autoFocus
            />
            {formik.touched.full_name && formik.errors.full_name ? (
              <Typography sx={{color: "#ff0000"}}>{formik.errors.full_name}</Typography>
            ) : (
              ""
            )}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <InputLabel htmlFor="email">Email</InputLabel>
            <TextField
              type="email"
              id="email"
              name="email"
              value={formik.values.email}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />
            {formik.touched.email && formik.errors.email ? (
              <Typography sx={{color: "#ff0000"}}>{formik.errors.email}</Typography>
            ) : (
              ""
            )}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <InputLabel htmlFor="phone">Phone</InputLabel>
            <TextField
              type="tel"
              id="phone"
              name="phone"
              value={formik.values.phone}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />
            {formik.touched.phone && formik.errors.phone ? (
              <Typography sx={{color: "#ff0000"}}>{formik.errors.phone}</Typography>
            ) : (
              ""
            )}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <InputLabel htmlFor="courseTitle">Course Title</InputLabel>
            <Select
              id="courseTitle"
              name="course_title"
              value={formik.values.course_title}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              label="select course"
            >
              <MenuItem value="">select course</MenuItem>
              <MenuItem value="Web Dev">Web Dev</MenuItem>
              <MenuItem value="Data Analysis">Data Analysis</MenuItem>
              <MenuItem value="Data Science">Data Science</MenuItem>
              <MenuItem value="UI/UX Design">UI/UX Design</MenuItem>
            </Select>
            {formik.touched.course && formik.errors.course_title ? (
              <Typography sx={{color: "#ff0000"}}>
                {formik.errors.course_title}
              </Typography>
            ) : (
              ""
            )}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <InputLabel htmlFor="occupation">Occupation</InputLabel>
            <TextField
              type="text"
              id="occupation"
              name="occupation"
              value={formik.values.occupation}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
            />
            {formik.touched.occupation && formik.errors.occupation ? (
              <Typography sx={{color: "#ff0000"}}>{formik.errors.occupation}</Typography>
            ) : (
              ""
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default PersonalInfo;
